/**
 * EP Studio — Frame swap toggle.
 * When a visitor picks Black on the framing add-on, auto-swap the PDP main
 * image to the black-frame mockup. Picking White, or unchecking the framing
 * add-on entirely, reverts to the default white-framed wall photo (slide 0).
 * Works generically across every product: it looks for the frame-addon
 * widget already rendered on the page and the media-gallery in the same
 * section, no per-product configuration needed.
 *
 * NOTE: this theme's slideshow slides carry no slide-id attribute, so
 * selection must be done by numeric index into gallery.slideshow.refs.slides,
 * not by slide-id (an earlier version of this script wrongly assumed
 * slide-id existed and silently did nothing).
 */
(function () {
  function getGallery(container) {
    var section = container.closest('.shopify-section, dialog');
    return section ? section.querySelector('media-gallery') : document.querySelector('media-gallery');
  }

  function findSlideIndexByImgMatch(gallery, matchFn) {
    if (!gallery || !gallery.slideshow || !gallery.slideshow.refs) return null;
    var slides = gallery.slideshow.refs.slides || [];
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      var src = img ? (img.currentSrc || img.src || '') : '';
      if (img && matchFn(src)) {
        return i;
      }
    }
    return null;
  }

  function wireContainer(container) {
    if (container.dataset.epFrameSwapWired) return;
    container.dataset.epFrameSwapWired = '1';

    var toggle = container.querySelector('input[type="checkbox"]');
    var radios = container.querySelectorAll('input[type="radio"]');
    if (!toggle || !radios.length) return;

    function swap(color) {
      // animate: false -- the color-frame swap should snap to the new image
      // instantly (no slide transition). The normal prev/next arrow buttons
      // are untouched by this script and keep their native sliding animation.
      var gallery = getGallery(container);
      if (!gallery || !gallery.slideshow) return;
      if (color === 'black') {
        var blackIndex = findSlideIndexByImgMatch(gallery, function (src) {
          return src.indexOf('black_frame') !== -1;
        });
        if (blackIndex !== null) gallery.slideshow.select(blackIndex, undefined, { animate: false });
      } else {
        gallery.slideshow.select(0, undefined, { animate: false });
      }
    }

    toggle.addEventListener('change', function () {
      if (toggle.checked) {
        var checkedRadio = container.querySelector('input[type="radio"]:checked');
        swap(checkedRadio ? checkedRadio.value : 'white');
      } else {
        swap('white');
      }
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (toggle.checked) swap(radio.value);
      });
    });
  }

  function scan() {
    document.querySelectorAll('.ep-frame-addon').forEach(wireContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
  var mo = new MutationObserver(function () {
    scan();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
